import * as React from 'react'
import { SVGProps } from 'react'

const SvgSquaresPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.167 9.667v5m-2.5-2.5h5M3 6.334h1.667a1.667 1.667 0 0 0 1.667-1.667V3a1.667 1.667 0 0 0-1.667-1.667H3A1.667 1.667 0 0 0 1.333 3v1.667A1.667 1.667 0 0 0 3 6.334Zm8.334 0H13a1.667 1.667 0 0 0 1.667-1.667V3A1.667 1.667 0 0 0 13 1.333h-1.666A1.667 1.667 0 0 0 9.667 3v1.667a1.667 1.667 0 0 0 1.667 1.667ZM3 14.666h1.667A1.667 1.667 0 0 0 6.334 13v-1.666a1.667 1.667 0 0 0-1.667-1.667H3a1.667 1.667 0 0 0-1.667 1.667V13A1.667 1.667 0 0 0 3 14.667Z"
      stroke="#5F41B2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgSquaresPlus
